import { useState } from 'react'

/**
 * Plain comma-separated multi-value input. User wpisuje "DRAFT,MONTAZ".
 * Wartość emit-owana jako tablica stringów. Dla multi=true gdy nie ma zdefiniowanego
 * dropdown source (V2 doda smart pickery dla team_ref/user_ref/select).
 */
export function MultiInput({ value, onChange }: { value: unknown; onChange: (v: string[]) => void }) {
  const initial = Array.isArray(value) ? (value as string[]).join(', ') : ''
  const [text, setText] = useState(initial)
  return (
    <input
      type="text"
      value={text}
      placeholder="DRAFT, MONTAZ, ..."
      onChange={e => {
        setText(e.target.value)
        onChange(e.target.value.split(',').map(s => s.trim()).filter(Boolean))
      }}
      className="border rounded px-2 py-1 text-sm flex-1"
    />
  )
}
